import { useAuth } from "@/contexts/AuthContext";
import ChangePasswordForm from "@/components/ChangePasswordForm";
import PreferencesSection from "@/components/PreferencesSection";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ShieldCheck } from "lucide-react";

export default function AdminAccountPage() {
  const { user } = useAuth();
  return (
    <div data-testid="admin-account-page">
      <header className="mb-8">
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-2">Settings</div>
        <h1 className="font-display uppercase text-4xl md:text-5xl font-bold tracking-tight">My Account</h1>
      </header>

      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-1 rounded-xl">
          <CardHeader>
            <CardTitle className="font-display uppercase tracking-tight text-xl">Profile</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Full name</div>
              <div className="mt-1">{user?.full_name}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Email</div>
              <div className="mt-1">{user?.email}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Role</div>
              <div className="mt-1 inline-flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-primary" /> Admin
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="lg:col-span-2 rounded-xl">
          <CardHeader>
            <CardTitle className="font-display uppercase tracking-tight text-xl">Change Password</CardTitle>
          </CardHeader>
          <CardContent>
            <ChangePasswordForm testIdPrefix="admin-change-password" />
          </CardContent>
        </Card>

        <div className="lg:col-span-3">
          <PreferencesSection testIdPrefix="admin-preferences" />
        </div>
      </div>
    </div>
  );
}
